import React, {useEffect, useState} from 'react';
import {Pagination, Avatar, Space, Spin} from "antd";
import StatisticsTable from "../../components/statisticsTable/statisticsTable";
import StatisticsFilter from "../../components/statisticsTable/statisticsFilter"; 
import axios from "axios";
import {Link} from "react-router-dom";
import AxiosRequest, {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
//import UserBan from "../../components/usersTable/userBan";
//import UsersDelete from "../../components/usersTable/usersDelete";
//import Complete from "../../components/noteTable/Complete";
/*import UsersRstore from "../../components/usersTable/usersRestore";
import RoomBan from "../../components/usersTable/roomBan";
import Break from '../../components/messagesTable/Break';*/

const StatisticsListPage = (props) => {
// data state to store the TV Maze API data. Its initial value is an empty array
    console.log('props',props.match.params);
    const [users, setMessages] = useState(null);
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);
    const [filters, setFilters] = useState({imba_id: props.match.params.imba_id, per_page: 10});
    const [loading, setLoading] = useState(false);
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            
        },
        {
            title: 'Login',
            dataIndex: 'login',
            key: 'login',
            render: text => <p>{text == 'NULL' ? 'No Text' : text}</p>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: text => <p>{text == 'NULL' ? 'No Text' : text}</p>,
        },
        {
            title: 'Rating',
            dataIndex: 'rating',
            key: 'rating',
            render: text => <p>{text}</p>,
        },
        {
            title: 'Maximum message response time',
            dataIndex: 'max',
            key: 'max',
            render: text => <p>{text}</p>,
        },
        {
            title: 'Minimum message response time',
            dataIndex: 'min',
            key: 'min',
            render: text => <p>{text}</p>,
        },
        {
            title: 'Number of requests processed',
            dataIndex: 'avg',
            key: 'avg',
            render: text => <p>{text}</p>,
        },
        /*{
            title: 'room_id',
            dataIndex: 'room_id',
            key: 'room_id',
            render: text => <p>{text == 'NULL' ? 'No ID' : text}</p>,
        },*/
        /*{
          title: 'avatar',
          key: 'avatar',
          render: (text, record) => <Avatar size={64} src={record.avatar_url} />
        },
        {
            title: 'login',
            dataIndex: 'login',
            key: 'login',
            render: text => <p>{text == 'NULL' ? 'NoName' : text}</p>,
        },
        {
            title: 'status',
            dataIndex: 'status',
            key: 'status',
            render: text => <p>{text == 'NULL' ? 'user' : text}</p>,
        },
        {
          title: 'Ban status',
          key: 'banStatus',
          dataIndex: 'bans',
          render: bans => {
              if (bans.length > 0)
              {
                  let ban = bans[bans.length-1];
                  let curr_date = new Date();
                  let unban_date = new Date(ban.unbanned_at)
                  if (curr_date>unban_date)
                  {
                      return (<p>not banned</p>)
                  }
                  let date = [pad(unban_date.getDate()), pad(unban_date.getMonth()+1), unban_date.getFullYear()].join('.');
                  let time = [pad(unban_date.getHours()), pad(unban_date.getMinutes())].join(':');
                  return (<p>banned for {`${date} ${time}`}</p>)
              } else
                return (<p>not banned</p>)
          }
        },*/
        /*{
            title: 'Actions',
            key: 'actions',
            render: ( text, record) => (
                <div>
                    
                    <Complete record={text} imba_id={props.match.params.imba_id}/>
                    
                    
                </div>
            )
        }*/
    ];

    function pad(s) { return (s < 10) ? '0' + s : s; }

    function onChangePage(page, size) {
        setFilters({
            ...filters,  //take existing key-value pairs and use them in our new state,
            page: page   //define new key-value pair with new uuid and [].
        })
    }
    function onChangeSize(current, size) {
        setFilters({
            ...filters.per_page = size,  //take existing key-value pairs and use them in our new state,
        })
    }

    // Using useEffect to call the API once mounted and set the data
    useEffect(() => {
        (async () => {
            
            AxiosRequestWithImba("get_statistics", filters, props.match.params.imba_id )
                .then((data) => {
                    console.log('message_list',data)
                    setLoading(false);
                    if(localStorage.getItem('role') != 'operator') {
                        setMessages(data)
                    }
                    else{
                        setMessages([])
                    }
                    /*setTotal(5)
                    setPer(1)*/
                })
                .catch((error) =>{
                    setLoading(false);
                    console.log(error)
                    //window.location.reload()
                    //window.location.href = `#/${props.match.params.imba_id}/signIn`
                });
        })();
    }, [filters]);

    const onChangeFilter = (values) => {
        setLoading(true);
        values.imba_id = props.match.params.imba_id;
        values.per_page = per;
        setFilters(values)

    }
    return (
        <div className="App">
            <StatisticsFilter onChange={onChangeFilter}/>
            <Space size="middle" className={'absolute'}>
                <Spin size="large" spinning={loading} className={'absolute'} />
            </Space>
            <StatisticsTable imba_id={props.match.params.imba_id} dataSource={users} columns={columns } total={total} per={per} />
            
        </div>

    );
}

export default StatisticsListPage;